import common from 'plugins/i18n/common.en.ts'
import entity from 'plugins/i18n/entity/index.en.ts'
import component from 'plugins/i18n/locales/component/index.en.ts'
import routeTitle from 'plugins/i18n/routeTitles.en.ts'
import notificationTypes from 'plugins/i18n/notificationTypes.en.ts'
import { file } from './file'

export const en = {
	entity,
	component,
	common,
	routeTitle,
	notificationTypes,
	file,
}
